// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer___3XjCE","push":"Footer__push___1O9-i","copyright":"Footer__copyright___2iEI-","footerNav":"Footer__footerNav___Fdte_","flag":"Footer__flag___1qEgJ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/Footer.less
 ** module id = 763
 ** module chunks = 0
 **/